import {auth} from './firebaseConfig';

export const signInAnon = async () => {
    auth.signInAnonymously().catch(function(error) {
      // Handle Errors here.
    
      if (error.code === 'auth/operation-not-allowed') {
        console.error('You must enable Anonymous auth in the Firebase Console.');
      } else {
        console.error(error.message);
      }
    });
}

export const signUpAdmin = async (email, password) => {
    const userAuth  = await auth.createUserWithEmailAndPassword(
        email,
        password
    );

    return await userAuth;
}

export const signInAdmin = async (email, password) => {
    const userAuth  = await auth.signInWithEmailAndPassword(
        email,
        password
    );

    return await userAuth;
}